import type { CustomRoleTaxonomySelection } from '@revelio/data-access';

export const roleTaxonomySelectionToAiSearchId = (
  selection: CustomRoleTaxonomySelection | undefined
): string => {
  if (!selection) return 'custom_role_default';
  if (selection.default === true) return 'custom_role_default';

  if (
    selection.taxonomyId !== undefined &&
    selection.taxonomyId !== null &&
    Number.isFinite(selection.taxonomyId) &&
    selection.taxonomyId > 60
  ) {
    return `custom_role_taxonomy_${selection.taxonomyId}`;
  }

  if (
    typeof selection.ricsK50Id === 'string' &&
    selection.ricsK50Id.trim() &&
    selection.ricsK50Id !== '0'
  ) {
    return `custom_role_rics_k50_${selection.ricsK50Id}`;
  }

  if (
    typeof selection.ricsK10Id === 'string' &&
    selection.ricsK10Id.trim() &&
    selection.ricsK10Id !== '0'
  ) {
    return `custom_role_rics_k10_${selection.ricsK10Id}`;
  }

  return 'custom_role_default';
};

export const getRoleTaxonomyId = (
  taxonomySelection: CustomRoleTaxonomySelection | undefined
) => {
  if (taxonomySelection === undefined) return undefined;

  if (
    taxonomySelection.taxonomyId !== undefined &&
    taxonomySelection.taxonomyId !== null
  ) {
    return taxonomySelection.taxonomyId;
  }

  if (taxonomySelection.default) {
    return 0;
  }

  if (taxonomySelection.ricsK10Id) {
    return Number(taxonomySelection.ricsK10Id) + 50;
  }

  if (taxonomySelection.ricsK50Id) {
    return Number(taxonomySelection.ricsK50Id);
  }

  return 0;
};
